@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;
@use "../zr-theme/functions/fonts" as f;
@use "../zr-theme/fonts/open-sans.scss";

// local component name
$component: 'zr-rating';

:host {
    width: 100%;
    align-self: center;

    .schema-org-prop {
        display: none;
    }
}

.#{$component}__header {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
}

.#{$component}__title {
    font-size: f.calc-em(16);
    font-weight: 700;
    color: var(--ci-neutral900);
}

.#{$component}__count {
    font-size: f.calc-em(14);
    font-weight: 400;
}

.#{$component}__button {
    transition: background-color .2s ease-out;
    font-size: f.calc-em(14);
    font-weight: 400;
    padding: 8px;
    text-align: center;
    text-decoration: none;
    border: 1px solid var(--ci-neutral400);
    border-radius: 4px;
    color: var(--ci-neutral900);
    background-color: var(--ci-neutral100);
    width: 100%;

    &:active,
    &:focus,
    &:hover {
        background-color: var(--ci-neutral300);
    }
}

.#{$component}__distribution {
    margin-bottom: 20px;
}

.#{$component}__modal {
    transition: transform .3s ease-out;
    border: solid 1px var(--ci-neutral400);
    position: fixed;
    inset: 0;
    background-color: var(--ci-neutral100);
    pointer-events: none;
    transform: translateX(100%);
    z-index: 10000;

    &.is-visible {
        transform: translateX(0);
        pointer-events: auto;
    }
}

.#{$component}__modal-wrapper {
    height: 100%;
    overflow: hidden;
}

.#{$component}__modal-close {
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: f.calc-em(16);
    line-height: 24px;
    text-align: left;
    background: none;
    border: none;
    border-bottom: solid 1px var(--ci-neutral200);
    width: 100%;
    padding: 8px;
    color: var(--ci-neutral900);

    @include i.get-icon-left(arrow-left);

    &::before {
        position: relative;
        top: 2px;
        height: 16px;
        width: 16px;
    }

    &:active,
    &:focus,
    &:hover {
        text-decoration: underline;
    }
}

.#{$component}__modal-headline {
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    font-size: f.calc-em(20);
    line-height: f.calc-em(18);
    color: var(--ci-neutral900);
    text-align: center;
    margin-top: 0;
}

.#{$component}__modal-content {
    padding: 8px;
    height: calc(100% - 41px);
    overflow-y: scroll;
}

.#{$component}__filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    p {
        font-family: 'Open Sans', sans-serif;;
        font-weight: 300;
        margin: 0;
        font-size: f.calc-em(16);
        line-height: 24px;
        color: var(--ci-neutral800);
    }
}

.#{$component}__filter-select {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    border: solid 1px var(--ci-neutral400);
    border-radius: 0;
    font-size: f.calc-em(18);
    padding: 7px;
    color: var(--ci-neutral900);
}

.#{$component}__review {
    margin-top: 24px;

    &:first-child {
        margin-top: 0;
    }
}

.#{$component}__review-header {
    display: flex;
    gap: 8px;
}

.#{$component}__review-author,
.#{$component}__review-date,
.#{$component}__review-content {
    font-family: 'Open Sans', sans-serif;
    margin: 0;
    line-height: 24px;
}

.#{$component}__review-author {
    font-size: f.calc-em(16);
    font-weight: 400;
}

.#{$component}__review-date {
    font-size: f.calc-em(14);
    font-weight: 300;
}

.#{$component}__review-content {
    font-size: f.calc-em(16);
    font-weight: 600;
}

// media query for tablet and above
@media only screen and (min-width: $tablet-screen) {
    .#{$component}__modal-headline {
        font-family: 'Open Sans', sans-serif;
        font-weight: 700;
        font-size: f.calc-em(26);
        color: var(--ci-neutral900);
    }

    .#{$component}__modal {
        transition: opacity .2s ease-out;
        content: '';
        background: rgba(0 0 0 / 30%);
        opacity: 0;

        &.is-visible {
            opacity: 1;
        }

        .#{$component}__distribution {
            max-width: 320px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    .#{$component}__modal-wrapper {
        background: var(--ci-neutral100);
        transition: opacity .2s ease-out;
        opacity: 0;
        position: absolute;
        inset: 50% auto auto 50%;
        max-height: 75vh;
        width: 100%;
        max-width: 645px;
        overflow: hidden;
        border-radius: 8px;
        box-shadow:
            0 4px 4px rgba(0 0 0 / 25%),
            0 -4px 10px rgba(0 0 0 / 5%),
            0 -1px 14px 6px rgba(0 0 0 / 5%);

        .is-visible & {
            transform: translate(-50%, -50%);
            opacity: 1;
        }
    }

    .#{$component}__modal-content {
        height: 100%;
        padding: 32px;
        overflow-y: scroll;
    }

    .#{$component}__modal-close {
        transition: transform 150ms ease-in;
        position: absolute;
        padding: 4px;
        top: 17px;
        right: 17px;
        height: 28px;
        width: 28px;

        @include i.get-icon-only(close);

        &::before {
            height: 20px;
            width: 20px;
            position: static;
            top: auto;
        }

        &:active,
        &:focus,
        &:hover {
            transform: rotate(90deg);
        }
    }
}
